import {classNames} from "../lib/functions";

export default function Container({ children, className = '' }) {
  return <div className={classNames('min-h-[60vh] mx-auto', className)}>{children}</div>
};
